/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
'use strict';var __importDefault=this&&this['__importDefault']||function(_0x262202){return _0x262202&&_0x262202['__esModule']?_0x262202:{'default':_0x262202};};Object['defineProperty'](exports,'__esModule',{'value':!0x0});const descriptor_1=__importDefault(require('./../descriptor'));class KeyValueDescriptor extends descriptor_1['default']{}exports['default']=KeyValueDescriptor,KeyValueDescriptor['DESCRIPTOR_NAME']='KeyValueDescriptor',KeyValueDescriptor['DESCRIPTOR']={'fields':{'key':{'type':'string','id':0x1},'value':{'type':'string','id':0x2}}};